export const locales = {
  'fr-FR': 'fr-FR',
  fr_FR: 'fr_FR',
  fr: 'fr',
} as const;
